/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BeneficiarioLoteAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_1 = 'autocomplete-1',
  AUTOCOMPLETE_2 = 'autocomplete-2',
  AUTOCOMPLETE_4 = 'autocomplete-4',
  AUTOCOMPLETE_5 = 'autocomplete-5',
  AUTOCOMPLETE_6 = 'autocomplete-6',
  AUTOCOMPLETE_7 = 'autocomplete-7',
  AUTOCOMPLETE_8 = 'autocomplete-8',
  AUTOCOMPLETE_9 = 'autocomplete-9',
  AUTOCOMPLETE_11 = 'autocomplete-11',
  AUTOCOMPLETE_12 = 'autocomplete-12',
  AUTOCOMPLETE_13 = 'autocomplete-13',
  AUTOCOMPLETE_14 = 'autocomplete-14',
  AUTOCOMPLETE_16 = 'autocomplete-16',
  AUTOCOMPLETE_17 = 'autocomplete-17',
  AUTOCOMPLETE_18 = 'autocomplete-18',
  AUTOCOMPLETE_19 = 'autocomplete-19',
  AUTOCOMPLETE_20 = 'autocomplete-20',
  AUTOCOMPLETE_SG_ESTADO = 'autocomplete-sgEstado',
  AUTOCOMPLETE_SG_ESTADO_NASC = 'autocomplete-sgEstadoNasc',
  AUTOCOMPLETE_TABELA_PRECO = 'autocomplete-tabela-preco',
  CARD_0 = 'card-0',
  CHECKLIST_0 = 'checklist-0',
  CONTEXTUAL_BAR_BENEF_LOTE = 'contextual-bar-benef-lote',
  DATE_FIELD_1 = 'date-field-1',
  DATE_FIELD_3 = 'date-field-3',
  DATE_FIELD_4 = 'date-field-4',
  DATE_FIELD_5 = 'date-field-5',
  DATE_FIELD_6 = 'date-field-6',
  DATE_FIELD_7 = 'date-field-7',
  DATE_FIELD_8 = 'date-field-8',
  DATE_FIELD_ADESAO = 'date-field-adesao',
  DATE_FIELD_DT_CONTRATACAO = 'date-field-dtContratacao',
  DATE_FIELD_RESCISAO = 'date-field-rescisao',
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  FETCH_2 = 'fetch-2',
  FETCH_3 = 'fetch-3',
  FETCH_5 = 'fetch-5',
  FETCH_6 = 'fetch-6',
  FETCH_7 = 'fetch-7',
  FETCH_8 = 'fetch-8',
  FETCH_9 = 'fetch-9',
  FETCH_10 = 'fetch-10',
  FETCH_11 = 'fetch-11',
  FETCH_12 = 'fetch-12',
  FETCH_13 = 'fetch-13',
  FETCH_14 = 'fetch-14',
  FETCH_15 = 'fetch-15',
  FETCH_16 = 'fetch-16',
  FETCH_17 = 'fetch-17',
  FETCH_18 = 'fetch-18',
  FETCH_19 = 'fetch-19',
  FETCH_20 = 'fetch-20',
  FETCH_DS_MUNICIPIO = 'fetch-dsMunicipio',
  FETCH_TABELA_PRECO = 'fetch-tabela-preco',
  FETCH_TITULARES_CONTRATO = 'fetch-titulares-contrato',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_58 = 'field-58',
  FIELD_59 = 'field-59',
  FIELD_60 = 'field-60',
  FIELD_61 = 'field-61',
  FIELD_62 = 'field-62',
  FIELD_63 = 'field-63',
  FIELD_64 = 'field-64',
  FIELD_65 = 'field-65',
  FIELD_66 = 'field-66',
  FIELD_ANEXOS = 'field-anexos',
  FIELD_CD_CBO = 'field-cdCbo',
  FIELD_CD_CEP = 'field-cdCep',
  FIELD_CD_DECLARACAO_NASC_VIVO = 'field-cdDeclaracaoNascVivo',
  FIELD_CD_MATRICULA_EST = 'field-cdMatriculaEst',
  FIELD_CD_MUNICIPIO_IBGE_NASC = 'field-cdMunicipioIbgeNasc',
  FIELD_CD_NACIONALIDADE = 'field-cdNacionalidade',
  FIELD_CD_TIPO_LOGRADOURO = 'field-cdTipoLogradouro',
  FIELD_CELULAR = 'field-celular',
  FIELD_DS_BAIRRO = 'field-dsBairro',
  FIELD_DS_COMPLEMENTO = 'field-dsComplemento',
  FIELD_DS_EMAIL = 'field-dsEmail',
  FIELD_DS_ENDERECO = 'field-dsEndereco',
  FIELD_DS_MUNICIPIO = 'field-dsMunicipio',
  FIELD_DS_MUNICIPIO_NASC_ESTRANGEIRO = 'field-dsMunicipioNascEstrangeiro',
  FIELD_DS_OBSERVACAO = 'field-dsObservacao',
  FIELD_DS_ORGAO_EMISSOR_CI = 'field-dsOrgaoEmissorCi',
  FIELD_DT_ADMISSAO = 'field-dtAdmissao',
  FIELD_DT_ADOCAO = 'field-dtAdocao',
  FIELD_DT_EMISSAO_CERT_CASAMENTO = 'field-dtEmissaoCertCasamento',
  FIELD_DT_EMISSAO_CI = 'field-dtEmissaoCi',
  FIELD_DT_INCLUSAO_OPERADORA = 'field-dtInclusaoOperadora',
  FIELD_DT_NASCIMENTO = 'field-dtNascimento',
  FIELD_DT_RESCISAO = 'field-dtRescisao',
  FIELD_IE_ESTADO_CIVIL = 'field-ieEstadoCivil',
  FIELD_IE_SEXO = 'field-ieSexo',
  FIELD_MOTIVO = 'field-motivo',
  FIELD_NM_MAE = 'field-nmMae',
  FIELD_NM_PAI = 'field-nmPai',
  FIELD_NM_PESSOA_FISICA = 'field-nmPessoaFisica',
  FIELD_NM_SOCIAL = 'field-nmSocial',
  FIELD_NM_TITULAR_INCLUSAO = 'field-nmTitularInclusao',
  FIELD_NR_CARTAO_NAC_SUS = 'field-nrCartaoNacSus',
  FIELD_NR_CERT_CASAMENTO = 'field-nrCertCasamento',
  FIELD_NR_CPF = 'field-nrCpf',
  FIELD_NR_CTPS = 'field-nrCtps',
  FIELD_NR_ENDERECO = 'field-nrEndereco',
  FIELD_NR_IDENTIDADE = 'field-nrIdentidade',
  FIELD_NR_PIS_PASEP = 'field-nrPisPasep',
  FIELD_NR_REG_GERAL_ESTRANG = 'field-nrRegGeralEstrang',
  FIELD_NR_SEQ_CODIGO_EXTERNO = 'field-nrSeqCodigoExterno',
  FIELD_NR_SEQ_CONGENERE = 'field-nrSeqCongenere',
  FIELD_NR_SEQ_FAIXA_SALARIAL = 'field-nrSeqFaixaSalarial',
  FIELD_NR_SEQ_LOCALIZACAO_BENEF = 'field-nrSeqLocalizacaoBenef',
  FIELD_NR_SEQ_MOTIVO_INCLUSAO = 'field-nrSeqMotivoInclusao',
  FIELD_NR_SEQ_PAIS = 'field-nrSeqPais',
  FIELD_NR_SEQ_PARENTESCO = 'field-nrSeqParentesco',
  FIELD_NR_SEQ_PLANO = 'field-nrSeqPlano',
  FIELD_NR_SEQ_SUBESTIPULANTE = 'field-nrSeqSubestipulante',
  FIELD_NR_SEQ_TITULAR_CONTRATO = 'field-nrSeqTitularContrato',
  FIELD_NR_SEQ_VINCULO_ESTIP = 'field-nrSeqVinculoEstip',
  FIELD_NR_SERIE_CTPS = 'field-nrSerieCtps',
  FIELD_NR_TITULO_ELEITOR = 'field-nrTituloEleitor',
  FIELD_SG_EMISSORA_CI = 'field-sgEmissoraCi',
  FIELD_SG_ESTADO = 'field-sgEstado',
  FIELD_SG_ESTADO_NASC = 'field-sgEstadoNasc',
  FIELD_TABELA_PRECO = 'field-tabela-preco',
  FIELD_TELEFONE = 'field-telefone',
  FIELD_UF_EMISSORA_CTPS = 'field-ufEmissoraCtps',
  FILE_UPLOADER_BENEF_INCLUSAO = 'file-uploader-benef-inclusao',
  FORM_ANEXOS = 'form-anexos',
  FORM_DADOS_BENEFICIARIO = 'form-dados-beneficiario',
  FORM_DADOS_CONTRATACAO = 'form-dados-contratacao',
  FORM_PORTABILIDADE = 'form-portabilidade',
  FORM_REPASSE = 'form-repasse',
  FORM_SCA = 'form-sca',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_6 = 'input-6',
  INPUT_7 = 'input-7',
  INPUT_8 = 'input-8',
  INPUT_9 = 'input-9',
  INPUT_10 = 'input-10',
  INPUT_11 = 'input-11',
  INPUT_12 = 'input-12',
  INPUT_13 = 'input-13',
  INPUT_14 = 'input-14',
  INPUT_15 = 'input-15',
  INPUT_16 = 'input-16',
  INPUT_17 = 'input-17',
  INPUT_18 = 'input-18',
  INPUT_19 = 'input-19',
  INPUT_20 = 'input-20',
  INPUT_21 = 'input-21',
  INPUT_22 = 'input-22',
  INPUT_23 = 'input-23',
  INPUT_24 = 'input-24',
  INPUT_26 = 'input-26',
  INPUT_27 = 'input-27',
  INPUT_28 = 'input-28',
  INPUT_29 = 'input-29',
  INPUT_NR_SEQ_CODIGO_EXTERNO = 'input-nrSeqCodigoExterno',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LOCATOR_0 = 'locator-0',
  LOCATOR_2 = 'locator-2',
  LOTE_ATTACHMENTS_LIST = 'lote-attachments-list',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_2 = 'mapper-2',
  MAPPER_4 = 'mapper-4',
  MAPPER_5 = 'mapper-5',
  MAPPER_6 = 'mapper-6',
  MAPPER_7 = 'mapper-7',
  MAPPER_8 = 'mapper-8',
  MAPPER_9 = 'mapper-9',
  MAPPER_11 = 'mapper-11',
  MAPPER_12 = 'mapper-12',
  MAPPER_13 = 'mapper-13',
  MAPPER_14 = 'mapper-14',
  MAPPER_15 = 'mapper-15',
  MAPPER_16 = 'mapper-16',
  MAPPER_17 = 'mapper-17',
  MAPPER_18 = 'mapper-18',
  MAPPER_19 = 'mapper-19',
  MAPPER_20 = 'mapper-20',
  MAPPER_ANEXOS = 'mapper-anexos',
  MAPPER_LOGRADOURO = 'mapper-logradouro',
  MAPPER_REGRA_SCA = 'mapper-regra-sca',
  MAPPER_TABELA_PRECO = 'mapper-tabela-preco',
  PANEL_3 = 'panel-3',
  PANEL_CARD = 'panel-card',
  PANEL_CONTROL_CARD = 'panel-control-card',
  PANEL_DETALHES_BENEF_LOTE = 'panel-detalhes-benef-lote',
  PANEL_STAMP = 'panel-stamp',
  PHONE_NUMBER_0 = 'phone-number-0',
  PHONE_NUMBER_1 = 'phone-number-1',
  STAMP_SITUACAO_LOTE = 'stamp-situacao-lote',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_11 = 'text-11',
  TEXT_12 = 'text-12',
  TEXT_13 = 'text-13',
  TEXT_14 = 'text-14',
  TEXT_15 = 'text-15',
  TEXT_16 = 'text-16',
  TEXT_17 = 'text-17',
  TEXT_18 = 'text-18',
  TEXT_19 = 'text-19',
  TEXT_20 = 'text-20',
  TEXT_21 = 'text-21',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_MOTIVO = 'text-motivo',
  TEXT_TABELA_PRECO = 'text-tabela-preco',
  WIZARD_DETALHES_BENEF_LOTE = 'wizard-detalhes-benef-lote',
  WIZARD_STEP_ANEXOS = 'wizard-step-anexos',
  WIZARD_STEP_DADOS_BENEFICIARIO = 'wizard-step-dados-beneficiario',
  WIZARD_STEP_DADOS_CONTRATACAO = 'wizard-step-dados-contratacao',
  WIZARD_STEP_PORTABILIDADE = 'wizard-step-portabilidade',
  WIZARD_STEP_REPASSE = 'wizard-step-repasse',
  WIZARD_STEP_SCA = 'wizard-step-sca',
}
export { BeneficiarioLoteAliases };
